var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"message",style:({ height: _vm.expanded ? '38px' : '0' })},[_c('span',{ref:"textSpan",staticClass:"typing-text"},[_c('v-icon',{staticStyle:{"color":"rgba(45, 180, 0, 1)","font-size":"20px","margin-right":"8px"}},[_vm._v("mdi-check-circle")]),_vm._v(" "+_vm._s(_vm.text))],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }